/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVClosedIcon20Regular = forwardRef('ArrowCollapseCVClosedIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.803 8.258a2.55 2.55 0 0 1-3.606 0L4.22 4.28a.75.75 0 0 1 1.06-1.06l3.978 3.977c.41.41 1.074.41 1.485 0L14.72 3.22a.75.75 0 1 1 1.06 1.06l-3.977 3.978Z" }),
        React.createElement("path", { d: "M11.803 11.742a2.55 2.55 0 0 0-3.606 0L4.22 15.72a.75.75 0 1 0 1.06 1.06l3.978-3.977a1.05 1.05 0 0 1 1.485 0l3.977 3.977a.75.75 0 1 0 1.06-1.06l-3.977-3.978Z" })));
});
